import * as React from "react";
import NumberPicker from "dt-design-system/es/number-picker";
import Select from "dt-design-system/es/select";
import message from "./message";
import css from "./pax-plan-form.module.css";

const AGES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

const AdultsLabel = ({ lang }) => {
  return (
    <div className={css.rowLabel}>
      {message(lang, "adults")}
      <sub className={css.rowLabelHelper}>{message(lang, "adults-helper")}</sub>
    </div>
  );
};

const Childrenlabel = ({ lang }) => {
  return (
    <div className={css.rowLabel}>
      {message(lang, "children")}
      <sub className={css.rowLabelHelper}>
        {message(lang, "children-helper")}
      </sub>
    </div>
  );
};

const PaxPlanForm = ({ lang, onChange, adults, children, agesChildren }) => {
  const [selectedAdults, setAdults] = React.useState(adults || 0);
  const [selectedChildren, setChildren] = React.useState(children || 0);
  const [selectedChildrenAges, setChildrenAges] = React.useState(
    agesChildren || []
  );

  const changeAdults = (val) => {
    setAdults(val);
    onChange({
      adults: val,
      children: selectedChildren,
      agesChildren: selectedChildrenAges,
    });
  };

  const changeChildren = (val) => {
    const oldVal = selectedChildren;
    const ages =
      val > oldVal
        ? [...selectedChildrenAges, 12]
        : selectedChildrenAges.slice(0, selectedChildrenAges.length - 1);
    setChildren(val);
    setChildrenAges(ages);
    onChange({ adults: selectedAdults, children: val, agesChildren: ages });
  };

  const changeAgeChildren = (index) => (e) => {
    const value = e.target.value;
    const ages = [
      ...selectedChildrenAges.slice(0, index),
      parseInt(value, 10),
      ...selectedChildrenAges.slice(index + 1),
    ];
    setChildrenAges(ages);
    onChange({
      adults: selectedAdults,
      children: selectedChildren,
      agesChildren: ages,
    });
  };

  const agesOptions = AGES.map((option) => ({
    label: `${option} ${message(lang, option < 2 ? "year" : "years")}`,
    value: option,
  }));

  return (
    <div className={css.form}>
      <div className={css.content}>
        <NumberPicker
          label={<AdultsLabel lang={lang} />}
          className="picker"
          min={0}
          max={20}
          value={selectedAdults}
          onChange={changeAdults}
        />
        <NumberPicker
          label={<Childrenlabel lang={lang} />}
          className="picker"
          min={0}
          max={9}
          value={selectedChildren}
          onChange={changeChildren}
        />
        {selectedChildren > 0 && (
          <div className={css.childrenAges}>
            <div className={css.childrenSuffix}>{message(lang, "age")}</div>
            {selectedChildrenAges.map((age, index) => (
              <div key={index} className={css.ageRow}>
                <div className={css.ageRowLabel}>
                  {message(lang, "child")} {index + 1}
                </div>
                <Select
                  options={agesOptions}
                  value={age}
                  onChange={changeAgeChildren(index)}
                  compact
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaxPlanForm;
